<script>
    import SEO from '$components/SEO.svelte';
</script>

<SEO title='CondoGenius - Something Went Wrong | Condo Reviews for Toronto and GTA' />

<section class='h-56 py-12 mt-20 w-full rounded-2xl text-black'>
    <h3 class='h1 text-4xl sm:text-5xl font-[600] mb-10'>
        Whoops! 500 Error
    </h3>
    <h4 class='text-xl sm:text-2xl'>
        We’re not sure what went wrong, <br />
        but we’ve notified the administrators. <br />
        They’ll fix this right away!
    </h4>
</section>

<section class='mt-20 pt-10'>
    <h3 class='h3 text-lg sm:text-2xl font-semibold mb-5'>
        Not to worry. Here's some quick detours that <br />
        won't take 20 minutes to reroute:
    </h3>
    <ul>
        <li class='text-primary-500 text-base sm:text-xl py-0.5 hover:text-primary-500'><a href='/'>Homepage</a></li>
        <li class='text-primary-500 text-base sm:text-xl py-0.5 hover:text-primary-500'><a href='/me'>My Account</a></li>
        <li class='text-primary-500 text-base sm:text-xl py-0.5 hover:text-primary-500'><a href='/buildings/search'>Search Condo Reviews by Neighbourhood</a></li>
        <li class='text-primary-500 text-base sm:text-xl py-0.5 hover:text-primary-500'><a href='/buildings/toronto'>Search All Buildings</a></li>
        <li class='text-primary-500 text-base sm:text-xl py-0.5 hover:text-primary-500'><a href='/add-review'>Add a Condo Review</a></li>
    </ul>
</section>

<style>
</style>
